<div id="fn-time-picker-container">
    <div class="fn-time-picker-search">
        <input class="form-control" [(ngModel)]="searchTerm" (click)="inputClick()" (keydown)="keydownEvent($event)" maxlength="17" (input)="filterTime($event)" [disabled]="isDisabled"
               [placeholder]="placeholder" />
        @if(isNextDay){
        <span class="mextDay">
            <span>+1 </span>
            <span>Day</span>
        </span>
        }
        <i class="fn-global-dropdownArrow" [ngClass]="{'fn-open-dropdown': showDropDown,'disable':isDisabled}" (click)="toggleSelect(showDropDown)"></i>
        @if ((uiItemArray && uiItemArray.length > 0) && showDropDown) {
        <ul class="fn-time-picker-ul" id="fn-time-picker-ul" [fnAppendTo]="appendTo" (outsideClick)="closeDropDown()">
            @for (item of uiItemArray; track item; let i = $index) {
            <li (mouseover)="activeItem=i" [ngClass]="{'active': activeItem === i  }" (click)="onItemClick()">{{item}}</li>
            }
        </ul>
        }
    </div>
</div>
@if (parentForm?.submitted && errorMessage && !showDropDown && !isDisabled) {
<span class="fn-msg-err text-break" [ngClass]="'bottom'">{{errorMessage| fnTranslate}}</span>
}